@if(isLoading) {
    <app-loading class="h-100 w-100 loading-container" [text]="'Loading'"></app-loading>
    } @else {
      <div class="button-list">
        <button class="release-btn btn-accello-secondary" (click)="addNewOperation()">
          <img
            [src]="'images/virtusa-icons/add-icon-dark.svg' | assetUrl"
            alt="Add Icon"
            width="18"
            height="18"
          />
          Add New Operation
        </button>
    
        <button
          class="release-btn btn-accello-light"
          (click)="removeOperations()"
          [disabled]="!selectedOperations.length"
          (focus)="changeRemoveIcon(false)"
          (mouseenter)="changeRemoveIcon(false)"
          (mouseleave)="changeRemoveIcon(false)"
          (blur)="changeRemoveIcon(false)"
          (mousedown)="changeRemoveIcon(true)"
          (mouseup)="changeRemoveIcon(false)"
        >
          <img [src]="iconSrcDelete | assetUrl" width="18" height="18" />
          <span> Remove Operations</span>
          @if(isLoading){
          <span class="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
          }
        </button>
    
        <button class="btn-accello-ternary" (click)="refreshData()">
          <img [src]="'images/virtusa-icons/sync.svg' | assetUrl" alt="refresh" />
          <span>Refresh</span>
        </button>
      </div>
    <div class="table-wrapper">
      <app-zorro-table
      tableId="rs-overview"
      class="application-overview"
      [data]="dataSource"
      [columns]="columns"
      [options]="options"
      (handleActions)="handleActionsInTable($event)"
      (onRowSelect)="handleRowSelect($event)"
    ></app-zorro-table>
    </div>
    }
    